function AdminEditIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.47653 0 0 4.47384 0 9.99399C0 15.5141 4.47653 20 10 20C15.5235 20 20 15.5141 20 9.99399C20 4.47384 15.5235 0 10 0ZM13.7064 8.73121C11.6606 10.7757 9.61492 12.8202 7.56919 14.8527C7.50903 14.9128 7.42479 14.9609 7.35259 14.985C6.46209 15.2135 5.5716 15.4299 4.69314 15.6464C4.66907 15.6585 4.64501 15.6705 4.63297 15.6705C4.58484 15.6825 4.5367 15.6825 4.5006 15.6705C4.40433 15.6705 4.33213 15.6103 4.30806 15.5021C4.29603 15.4179 4.29603 15.4059 4.3201 15.3458C4.38026 15.0932 4.45247 14.8527 4.51264 14.6121C4.68111 13.9507 4.83754 13.2892 5.00602 12.6278C5.03008 12.5556 5.06618 12.4955 5.11432 12.4474C7.17208 10.3909 9.21781 8.33434 11.2756 6.28984C11.2996 6.26579 11.3117 6.24173 11.3237 6.22971C12.142 7.0475 12.9483 7.85328 13.7665 8.67108C13.7545 8.67108 13.7304 8.70716 13.7064 8.73121ZM15.4513 6.96332C15.4513 6.96332 15.367 7.07156 15.3069 7.13169C15.0421 7.4083 14.7653 7.67288 14.4886 7.94949C13.6823 7.13169 12.864 6.32592 12.0578 5.50812C12.2744 5.29164 12.491 5.06314 12.7196 4.84666C12.8279 4.73843 12.9242 4.63019 13.0445 4.546C13.4898 4.20926 14.1637 4.23331 14.5848 4.61816C14.8616 4.88274 15.1384 5.14732 15.3911 5.43596C15.7762 5.85689 15.8002 6.50631 15.4513 6.96332Z"
        fill="#F6A000"
      />
    </svg>
  );
}

export { AdminEditIcon };
